<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  ></yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { getId } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { EVENT_TYPES } from "../Event/event-utils";
import { mapState } from "vuex";
import { DEFAULT_OPTION_ALL } from "@/constants";

export default {
  name: "student-search-bar",
  components: { YvFormSearch },
  inject: ["refetchEvents"],
  data() {
    const eventTypeOpts = [
      ...DEFAULT_OPTION_ALL,
      {
        id: EVENT_TYPES.schoolEvent,
        name: this.$t("schedule.school_event")
      },
      {
        id: EVENT_TYPES.classEvent,
        name: this.$t("schedule.class_schedule")
      },
      {
        id: EVENT_TYPES.meetingEvent,
        name: this.$t("schedule.virtual_meeting")
      }
    ];
    return {
      formSearch: [
        {
          label: this.$t("schedule.student_filter_event_type"),
          name: "type",
          value: "",
          options: eventTypeOpts,
          type: "select"
        }
      ]
    };
  },
  watch: {
    "formSearch.0.value": function(newSelectedEventType) {
      if (this.formSearch.length >= 2) {
        this.removeFilterByClassField();
      }

      const isClassScheduleFiltering =
        newSelectedEventType === EVENT_TYPES.classEvent ||
        newSelectedEventType === EVENT_TYPES.meetingEvent;
      if (isClassScheduleFiltering) {
        this.appendFilterByClassField();
      }
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"])
  },
  methods: {
    search() {
      this.refetchEvents();
    },
    fetchEnrolledClasses() {
      const studentId = getId(this.currentChild);
      const queryParams = {
        limit: 20,
        student_id: studentId,
        status: "On-going"
      };

      return this.$axios
        .get(service_paths.classes, queryParams)
        .then(response => {
          const options = response?.data?.data.map(classInfo => ({
            id: getId(classInfo),
            name: classInfo.name
          }));

          return [...DEFAULT_OPTION_ALL, ...options];
        });
    },
    generateClassFilter(options) {
      return {
        label: this.$t("schedule.student_filter_class_event"),
        name: "class_id",
        value: "",
        options,
        type: "select"
      };
    },
    async appendFilterByClassField() {
      const enrolledClasses = await this.fetchEnrolledClasses();
      const filterByClassField = this.generateClassFilter(enrolledClasses);

      return (this.formSearch = [...this.formSearch, filterByClassField]);
    },
    removeFilterByClassField() {
      this.formSearch.splice(1);
    },
    getQueryParams() {
      const searchingParams = this.$refs.formSearch.getQueryParams();
      const extraParams = {
        children_id: getId(this.currentChild)
      };
      return {
        ...searchingParams,
        ...extraParams
      };
    }
  }
};
</script>
